import $ from 'jquery';
	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	function initMap( $el ) {

		// Find marker elements within map.
		var $markers = $el.find('.map__marker');
		// Create gerenic map.
		var mapArgs = {
			zoom        : $el.data('zoom') || 16,
			mapTypeId   : google.maps.MapTypeId.ROADMAP,
      center		: new google.maps.LatLng($el.attr('data-x'), $el.attr('data-y')),
			disableDefaultUI: true,
			styles: [   {     "featureType": "landscape.man_made",     "elementType": "geometry",     "stylers": [       {         "color": "#d5eef3"       }     ]   },   {     "featureType": "landscape.natural",     "elementType": "geometry",     "stylers": [       {         "color": "#eff3f6"       }     ]   },   {     "featureType": "poi",     "elementType": "labels",     "stylers": [       {         "visibility": "off"       }     ]   },   {     "featureType": "road",     "elementType": "geometry.stroke",     "stylers": [       {         "visibility": "off"       }     ]   },   {     "featureType": "road",     "elementType": "labels.text.fill",     "stylers": [       {         "color": "#0050a0"       }     ]   },   {     "featureType": "water",     "elementType": "geometry",     "stylers": [       {         "color": "#0050a0"       }     ]   },   {     "featureType": "water",     "elementType": "labels",     "stylers": [       {         "visibility": "off"       }     ]   } ],
			gestureHandling: 'cooperative',
		};
		var map = new google.maps.Map( $el[0], mapArgs );

		// Add markers.
		map.markers = [];
		$markers.each(function(){
			initMarker( $(this), map );
		});


		// Center map based on markers.
		centerMap( map );

		// Return map instance.
		return map;
	}

  var infowindow = new google.maps.InfoWindow({});

	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	function initMarker( $marker, map ) {
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

		// Get image for mapMarker
		const icon = "../wp-content/themes/alv/resources/img/marker.svg";

		// Create marker instance.
		var marker = new google.maps.Marker({
			position : latlng,
			map: map,
			icon: icon,
		});

		// Append to reference for later use.
		map.markers.push( marker );

		// If marker contains HTML, add it to an infoWindow.
		if( $marker.html() ){


		//Show info window when marker is clicked.
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.close();
				infowindow = new google.maps.InfoWindow({
					content: $marker.html(),
				});

				infowindow.open(map, this);
			});

			google.maps.event.addListener(map, 'click', function() {
				infowindow.close();
			});

		}
	}


	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   object The map instance.
	 * @return  void
	 */
	function centerMap( map ) {
		let centerLat = parseInt($('.map__container').attr('data-x'))
		let centerLng = parseInt($('.map__container').attr('data-y'))



		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng(),
			});
		});

		// Case: Single marker.
		if( map.markers.length == 1 ){
			map.setCenter( bounds.getCenter() );

			// Case: Multiple markers.
    } else{
			// map.fitBounds( bounds );
      map.setCenter( bounds.getCenter() );
      map.setZoom( $('.map__container').data('zoom') || 15);

			if (centerLat && centerLng) {
				map.setCenter({lat:centerLat, lng:centerLng});
			}
		}
	}

// Render maps on page load.
	$(document).ready(function(){
		$('.map__container').each(function(){
			var map = initMap( $(this) );
      return map
		});
	});

